var DateFormat = {

    parseDate: function(date_str, time_str, tz_offset)
    {
        var matches;
        var year, month, day, hours, minutes;

        var now = new Date();

        if (date_str && (matches = date_str.match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/))) {
            year = parseInt(matches[1]);
            month = parseInt(matches[2]) - 1;
            day = parseInt(matches[3]);
        } else {
            year = now.getFullYear();
            month = now.getMonth();
            day = now.getDate();
        }

        matches = time_str ? time_str.match(/([0-9]{1,2}):([0-9]{1,2})(am|pm)/) : null;
        if (matches) {
            hours = parseInt(matches[1]);
            minutes = parseInt(matches[2]);

            if (hours == 12) {
                hours = 0;
            }
 
            if (matches[3] == 'pm') {
                hours += 12;           
            }
       }  else {
            hours = now.getHours();
            minutes = now.getMinutes();
        }

    /*
        if (arguments.length >=3) {
            var date = new Date(Date.UTC(year, month, day, hours, minutes)); 
            date.setSeconds(date.getSeconds() + tz_offset);
        } else {
            var date = new Date(year, month, day, hours, minutes); 
        }
    */
        var date = new Date(year, month, day, hours, minutes); 

        if (arguments.length >= 3) {
            var offset = 0 - date.getTimezoneOffset();

            date.setMinutes(date.getMinutes() + tz_offset - offset);
        }

        return date;
    },

    formatDate: function(date)
    {
        var str = '';
        
        str += date.getFullYear();
        str += '-';
   
        var month = date.getMonth() + 1;
        if (month < 10) {
            str += '0';
        }
        str += month;
        str += "-";
        
        var day = date.getDate();
        if (day < 10) {
            str += "0";
        }
        str += day;


        return str;
    },

    formatTime: function(date)
    {
        if (!date) {
            return;
        }

        var hours = date.getHours();
        var minutes = date.getMinutes();

        var time = '';
        if (hours === 0) {
            time += '12';
        } else if (hours < 10) {
          //  time += '0';
            time += hours;
        } else if (hours >= 13) {
            time += hours - 12;
        } else {
            time += hours;
        }

        time += ':';

        if (minutes < 10) {
            time+= '0';
        }
        
        time+= minutes;
        time += hours >= 12 ? 'pm' : 'am';
        
        return time;            
    }
};
